/**
 * DataSource — the single concrete `dataSource` row type.
 *
 * Owns or holds cells across every `(dtype, cardinality)` combination
 * today — text / number / boolean / obj / graph / series / heatmap.
 * Transparent in rendering: the `column.*` renderer child auto-
 * hydrated by `hydrateDefaultRenderer` paints the cells and accepts
 * typed edits. Typed APIs (`peekText` / `writeText` / `peekNumber` /
 * `peekChecked` / …) live on those renderer subclasses, not here
 * (renderer-as-editor: a renderer both paints and edits its source's
 * cells).
 *
 * `FormulaDataSource` is the only peer — it extends `SourceRow`
 * separately because its `expression` / cycle detection / write-
 * rejection semantics diverge from user-backed sources. Every other
 * wire type (`text` / `number` / `boolean` / `calendar` / `weather` /
 * `data-json` / …) resolves to `DataSource`.
 */

import { SourceRow } from "./source-row.ts";

/**
 * The concrete `dataSource` row: holds cells of any type, painted and edited through its
 * auto-hydrated `column.*` renderer child.
 */
export class DataSource extends SourceRow {}
